export default {
  priority: 95,
  name: app.translate("routes.home.attendance.leave.Report leave"),
  path: "Leave/report",
  permissions: [
    "TimeAttendanceMenu/RemainingLeaveMenu/RemainingLeaveReportMenu",
  ],
  component: load(() =>
    import(/* webpackChunkName: "auto transfer" */ "./LeaveReport")
  ),
  icon: "file-chart",
  drawer: true,
};
